module.exports = __webpack_public_path__ + "img/gq13.ca2b5ee9.png";